/**
 * Tabs Module
 * Custom tab functionality
 */

export function initTabs() {
  try {
    const tabContainers = document.querySelectorAll("[data-tabs]");

    if (tabContainers.length === 0) {
      console.log("No tab containers found");
      return;
    }

    tabContainers.forEach((container, index) => {
      setupCustomTabs(container, index);
    });

    console.log(`✅ Custom tabs initialized for ${tabContainers.length} containers`);
  } catch (error) {
    console.error("❌ Error initializing custom tabs:", error);
  }
}

function setupCustomTabs(container, containerIndex) {
  const triggers = container.querySelectorAll("[data-tabby]");
  const panels = [];

  // Collect all panels
  triggers.forEach((trigger) => {
    const targetId = trigger.getAttribute("data-tabby");
    const panel = document.querySelector(targetId);
    if (panel) {
      panels.push({ trigger, panel, targetId });
    }
  });

  if (panels.length === 0) {
    console.log(`No valid tab panels found for container #${containerIndex + 1}`);
    return;
  }

  // Setup click handlers
  panels.forEach(({ trigger, panel }, index) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      activateTab(panels, index);
    });

    // Add ARIA attributes for accessibility
    trigger.setAttribute("role", "tab");
    trigger.setAttribute("aria-selected", "false");
    panel.setAttribute("role", "tabpanel");
    panel.setAttribute("aria-hidden", "true");
  });

  // Activate first tab
  activateTab(panels, 0);
}

function activateTab(panels, activeIndex) {
  panels.forEach(({ trigger, panel }, index) => {
    const isActive = index === activeIndex;

    // Update trigger state
    trigger.classList.toggle("active", isActive);
    trigger.setAttribute("aria-selected", isActive.toString());

    // Update panel state
    panel.style.display = isActive ? "block" : "none";
    panel.classList.toggle("active", isActive);
    panel.setAttribute("aria-hidden", (!isActive).toString());
  });
}
